export default __webpack_public_path__ + "static/media/Access_icon.927b4d05.svg";